import axios from "axios";
import { toast } from "react-toastify";
import axiosClient from "./axiosClient";

/**
 * @description registration in db.
 * @param {*} data
 * @param {*} callback
 */

// Get all patients
export const getPatients = async (params) => {
  try {
    const response = await axiosClient.get(`/patient-service/get-all-patient`, {
      params,
    });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching patients:", err);
    toast.error("An error occurred while fetching patients.");
  }
};

// Delete a patient
export const deletePatientApi = async (id) => {
  try {
    const response = await axiosClient.put(
      `/patient-service/update-patient?patientId=${id}`,
      { isDelete: true }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error deleting patient:", err);
    toast.error("An error occurred while deleting the patient.");
  }
};

// Get symptoms of a patient
export const getPatientSymptoms = async (id, params) => {
  try {
    const response = await axiosClient.get(
      `/patient-service/get-symptoms?patientId=${id}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching patient symptoms:", err);
    toast.error("An error occurred while fetching patient symptoms.");
  }
};

// Get bladdar journal of a patient
export const getPatientBladderJournal = async (id, params) => {
  try {
    const response = await axiosClient.get(
      `/patient-service/bladderdiary?patientId=${id}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patient symptoms.");
  }
};

// Get treatment plan of a patient
export const getPatientTreatmentPlan = async (params) => {
  try {
    const response = await axiosClient.get(
      `/medication-service/treatment/tretment-plan-patient/${params.patientId}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching the treatment plan.");
  }
};

// Get medication plan of a patient
export const getPatientMedicationPlan = async (params) => {
  try {
    const response = await axiosClient.get(
      `/medication-service/medication/medication-plan-patient/${params.patientId}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    }
  } catch (err) {
    toast.error("An error occurred while fetching the medication plan.");
  }
};

// Get patient adherence data
export const getPatientAdherance = async (params) => {
  try {
    const response = await axiosClient.get(
      `/medication-service/adherence/${params.patientId}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patient adherence data.");
  }
};

// Get patient documentgs list data
export const getPatientDocumetsList = async (params) => {
  try {
    const response = await axiosClient.get(
      `/patient-service/patient-documents/${params.patientId}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patient adherence data.");
  }
};

// ************************************services for notes ***************************************************************
// to get all notes for a patient id
// Get all notes for a patient by patient ID
export const getPatientNotesById = async (params) => {
  try {
    const response = await axiosClient.get(
      `/patient-service/note/${params.patientID}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patient notes.");
  }
};

// Get all notes for a patient by record ID
export const getPatientNotesByRecordId = async (params) => {
  try {
    const response = await axiosClient.get(
      `/patient-service/note/${params.patientId}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patient notes.");
  }
};

// Create a new note
export const CreateNote = async (data) => {
  try {
    const response = await axiosClient.post(`/patient-service/note`, data);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while creating a note.");
  }
};

// Update an existing note
export const updateNote = async (data) => {
  try {
    const response = await axiosClient.put(
      `/patient-service/note/${data._id}`,
      data
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while updating the note.");
  }
};

export const deletePatient = async (data) => {
  try {
    const response = await axiosClient.patch(
      `/patient-service/note/${data}`,
      {}
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while deleting the patient.");
  }
};

/**
 * @description contactUs in db.
 * @param {*} data
 * @param {*} callback
 */

const ProviderService = {
  getPatients,
};

export default ProviderService;
